const global = window

inputs.types.code = function (data, name, niceName, type, input, parent, inputWindow) {
    if (typeof pluginCode !== 'undefined') {
        pluginCode.init(input);
    }
    return data
}
